import { Stack, Divider } from '@mui/material'
import React from 'react'
import { NavigationTextLink } from 'components/atoms/link/navigation_text_link'
import { Minimal } from 'components/atoms/typography/minimal'

export const FooterBottom: React.FC<NoProps> = () => (
  <Stack
    flexDirection={{ xs: 'column', lg: 'row' }}
    justifyContent="space-between"
    rowGap={2}
    sx={{
      py: { xs: 2, lg: 4 },
      borderTop: 1,
      borderColor: (theme) => theme.palette.divider,
    }}
  >
    <Stack flexDirection="row" alignItems="center">
      <NavigationTextLink
        to="https://giftee.co.jp/"
        variant="button"
        target="_blank"
        rel="noopener noreferrer"
      >
        会社概要
      </NavigationTextLink>
      <Divider orientation="vertical" sx={{ mx: 2, height: 8 }} />
      <NavigationTextLink
        to="https://giftee.co.jp/privacypolicy/"
        variant="button"
        target="_blank"
        rel="noopener noreferrer"
      >
        プライバシーポリシー
      </NavigationTextLink>
      <Divider orientation="vertical" sx={{ mx: 2, height: 8 }} />
      <NavigationTextLink to="/inquiry/" variant="button">
        お問合せ
      </NavigationTextLink>
    </Stack>
    <Minimal>© giftee Inc.</Minimal>
  </Stack>
)
